<app-pcbread-crumb [data]="'Pharmacy,TechnicalRight'"></app-pcbread-crumb>
<app-pccrud [endPoint]="'TechnicalRight'"></app-pccrud>

